import { GeneralStyle } from '@website-builder/model/style/general-style';

export class MapStyle extends GeneralStyle {
  height = 300;
  mapWidth = 0;

  static normalize(styles: Partial<MapStyle>): MapStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new MapStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.height = styles.height ?? pureStyles.height;
    pureStyles.mapWidth = styles.mapWidth ?? pureStyles.mapWidth;

    return pureStyles;
  }
}
